var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.$t('components.partners.WithdrawalOfPartners')))]),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/partnersWithdrawals/create?partner_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.partners.addition'))+" ")])],1),_c('indexTable',{attrs:{"searchText":_vm.$t('partnersWithdrawals.SearchForAnOperation'),"emptyTableText":_vm.$t('partnersWithdrawals.thereAreNoWithdrawalsOperations'),"filter":{ partner_id: _vm.$route.params.id },"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"withoutCard":true,"cloumns":[
        {
          column: 'code',
          title: _vm.$t('partnersWithdrawals.Process'),
          type: 'mainLink',
          sort: true
        },
        {
          column: 'partner_id',
          title: _vm.$t('partnersWithdrawals.PartnerName'),
          type: 'link',
          to: 'partner',
          sort: true,
          link: true
        },
        {
          column: 'safe_id',
          title: _vm.$t('partnersWithdrawals.Treasury'),
          type: 'link',
          to: 'safe',
          sort: true,
          link: true
        },
        {
          column: 'date',
          title: _vm.$t('partnersWithdrawals.date'),
          type: 'text',
          sort: true
        },
        {
          column: 'description',
          title: _vm.$t('partnersWithdrawals.AndThatIsAbout'),
          type: 'text',
          sort: true
        },
        {
          column: 'cost',
          title: _vm.$t('partnersWithdrawals.cost'),
          type: 'text',
          sort: true
        },
        {
          column: 'options',
          title: _vm.$t('partnersWithdrawals.actions'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role: _vm.$checkRole('partners_withdrawals_edit')
            },
            { name: 'printPurchasePayment', role: true },
            { name: 'download', role: true },
            {
              name: 'delete',
              role: _vm.$checkRole('partners_withdrawals_delete')
            }
          ]
        }
      ],"deleteText":{
        attention: _vm.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem: _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
        close: _vm.$t('allerts.close'),
        confirm: _vm.$t('allerts.confirm'),
        loading: _vm.$t('allerts.loading')
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }